/**
 * Per-resource access on the client (specs/access-model.md) — kept in sync
 * with ACTION_RANKS in apps/backend/src/auth/access.js, the way roles.js
 * mirrors the backend's role ranks. The grants come from /auth/me:
 * `me.grants = { instance: { id: action }, dataset: { id: action } }`.
 * A higher action includes the lower ones. Admins and owners don't appear
 * here: hasRole(user, 'admin') bypasses every resource check, as on the server.
 */
export const ACTION_RANKS = {
  instance: { manage: 4, facilitate: 3, participate: 2, read: 1 },
  dataset: { manage: 3, contribute: 2, view: 1 },
};

export function actionRank(resourceType, action) {
  return ACTION_RANKS[resourceType]?.[action] ?? 0;
}

/** Does this user's grant on the resource reach `action`? (Role bypass is the caller's.) */
export function canOnResource(user, resourceType, resourceId, action) {
  if (!resourceId || !actionRank(resourceType, action)) return false;
  const held = user?.grants?.[resourceType]?.[String(resourceId)];
  return actionRank(resourceType, held) >= actionRank(resourceType, action);
}

export const canOnInstance = (user, instanceId, action) =>
  canOnResource(user, 'instance', instanceId, action);

/** The instance ids this user holds any grant on. */
export const grantedInstanceIds = (user) => Object.keys(user?.grants?.instance || {});
